import { render } from "react-dom";
import { createElement } from "react";
import { Components_WordleSolver } from "./Components.fs.js";
import "./styles/main.css";


render(createElement(Components_WordleSolver, null), document.getElementById("feliz-app"));

